
import { GridColumns } from '@mui/x-data-grid-pro'
import { WorkbenchDto } from '@services/dtos'
import { useEffect, useMemo, useState } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import WorkbenchForm from '../forms/WorkbenchForm'
import { getWorkbenches, removeWorkbench, setWorkbenchFilters, updateWorkbench } from '@state/reducers/workbenchReducer'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import { Dialog, DialogContent } from '@mui/material'
import { UpTransition } from '../animations'
import WorkbenchGeneratorInstanceForm from '../forms/WorkbenchGeneratorInstanceForm'

export default function WorkbenchesTable() {
  const [workbenchGeneratorInstanceConfig, setWorkbenchGeneratorInstanceConfig] = useState<WorkbenchDto | null>(null)
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setWorkbenchFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<WorkbenchDto> = useMemo(
    () => [
      { field: 'code', headerName: 'Code', width: 60 },
      { field: 'name', headerName: 'Nom', width: 200 },
      { field: 'roomLabel', headerName: 'Salle', width: 150, valueGetter: (params) => params.row.room.label },
      { field: 'generatorSlotCount', headerName: 'Emplacements générateur', width: 200, valueGetter: (params) => 
        `${params.row.generatorSlots.length}${params.row.generatorSlots.length > 0 ? ` (${params.row.generatorSlots.map(({ name }) => name).join(', ')})` : ''}` },
      { field: 'wasteContainers', headerName: 'Conteneurs déchet', 
        valueGetter: (params) => params.row.wasteContainers.map(({ label }) => label).join(', '), width: 150 },
      { field: 'hotLabEquipments', headerName: 'Matériel laboratoire', 
        valueGetter: (params) => params.row.hotLabEquipments.map(({ name }) => name).join(', '), width: 155 },
    ],
    [],
  )

  return (
    <>
      <BaseConfigTable<WorkbenchDto>
        columns={columns}
        selectRows={(state) => state.workbench.crud.items}
        fetchThunk={() => async (dispatch: AppDispatch) => {
          dispatch(setWorkbenchFilters({ includeInactive: true }))
          return dispatch(getWorkbenches())
        }}
        extraActions={[
          {
            key: 'setGeneratorInstance',
            label: 'Modifier générateurs',
            icon: <HubOutlinedIcon color="primary" fontSize='small' />,
            onClick: (row) => {
              setWorkbenchGeneratorInstanceConfig(row)
            },
            disabled: (row) => row.generatorSlots.length === 0,
          },
        ]}
        deleteThunk={removeWorkbench}
        toggleThunk={(id, isActive) => updateWorkbench({ id, dto: { isActive } })}
        updatePageThunk={(page) => async (dispatch: AppDispatch) => {
          dispatch(setWorkbenchFilters({ page }))
          dispatch(getWorkbenches())
        }}
        FormComponent={({ editingItem, onClose }) => (
          <WorkbenchForm editingWorkbench={editingItem} onClose={onClose} />
        )}
        resourceLabel="enceinte blindée"
        resourcePrefix="l' "
      />

      <Dialog 
        fullWidth
        maxWidth="sm"
        open={workbenchGeneratorInstanceConfig !== null}
        TransitionComponent={UpTransition}
        onClose={() => setWorkbenchGeneratorInstanceConfig(null)}>
        <DialogContent>
          {workbenchGeneratorInstanceConfig && 
            <WorkbenchGeneratorInstanceForm
              workbench={workbenchGeneratorInstanceConfig}
              onClose={() => setWorkbenchGeneratorInstanceConfig(null)}
            />}
        </DialogContent>
      </Dialog>
    </>
  )
}
